import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
// import Label from 'src/components/label';
// import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';
import { batch } from 'react-redux';


// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  user: icon('ic_user'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  mail: icon('ic_mail'),
  subscription: icon('ic_file'),
  product: icon('ic_product'),
  blog: icon('ic_blog'),
  contact: icon('ic_contact'),
  category: icon('ic_categories'),
  job: icon('ic_job'),
  batch: icon('ic_batch'),
  faqCategory: icon('ic_faqCategory'),
  faq: icon('ic_faq'),
  conversion: icon('ic_conversion'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('overview'),
        items: [{ title: t('Dashboard'), path: paths.dashboard.root, icon: ICONS.dashboard }],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: t('management'),
        items: [
          
          {
            title: t('Business Listings'),
            path: paths.dashboard.contact.root,
            icon: ICONS.contact,
            children: [{ title: t('list'), path: paths.dashboard.contact.list }],
          },
          // USER
          {
            title: t('About & Contact'),  
            path: paths.dashboard.user.root,
            icon: ICONS.user,
            children: [
              { title: t('list'), path: paths.dashboard.user.list },
              { title: t('create'), path: paths.dashboard.user.new },
            ],
          },
          // CURRENCY EXCHANGE
          // {
          //   title: t('Currency Exchange'),
          //   path: paths.dashboard.currencyExchange.root,
          //   icon: ICONS.conversion,
          // },


          // {
          //   title: t('Fobo Pro Analytics'),
          //   path: paths.dashboard.profileAnalytics.root,
          //   icon: ICONS.analytics,
          //   children: [
          //     // { title: t('list'), path: paths.dashboard.plan.list },
          //     { title: t('list'), path: paths.dashboard.profileAnalytics.list },
          //   ],
          // },

          {
            title: t('Services'),
            path: paths.dashboard.plan.root,
            icon: ICONS.product,
            children: [
              // { title: t('list'), path: paths.dashboard.plan.list },
              { title: t('course list'), path: paths.dashboard.plan.courseList },

              { title: t('service list'), path: paths.dashboard.plan.serviceList },
              { title: t('create'), path: paths.dashboard.plan.new },
            ],
          },
          // {
          //   title: t('Batches'),
          //   path: paths.dashboard.batches.root,
          //   icon: ICONS.batch,
          //   children: [{ title: t('list'), path: paths.dashboard.batches.list },
          //   { title: t('create'), path: paths.dashboard.batches.new }
          //   ],
          // },
          // {
          //   title: t('Invoices'),
          //   path: paths.dashboard.subscription.root,
          //   icon: ICONS.subscription,
          //   children: [{ title: t('list'), path: paths.dashboard.subscription.list },
          //     // { title: t('details'), path: paths.dashboard.subscription.details},
          //   ],
          // },

          // {
          //   title: t('Category'),
          //   path: paths.dashboard.category.root,
          //   icon: ICONS.category,
          //   children: [{ title: t('list'), path: paths.dashboard.category.list },
          //   { title: t('create'), path: paths.dashboard.category.new }
          //   ],
          // },
          // {
          //   title: t('Faq Category'),
          //   path: paths.dashboard.faqCategory.root,
          //   icon: ICONS.faqCategory,
          //   children: [{ title: t('list'), path: paths.dashboard.faqCategory.list },
          //   { title: t('create'), path: paths.dashboard.faqCategory.new }
          //   ],
          // },
          // {
          //   title: t('Faq'),
          //   path: paths.dashboard.faq.root,
          //   icon: ICONS.faq,
          //   children: [{ title: t('list'), path: paths.dashboard.faq.list },
          //   { title: t('create'), path: paths.dashboard.faq.new }
          //   ],
          // },
          // {
          //   title: t('jobs'),
          //   path: paths.dashboard.job.root,
          //   icon: ICONS.job,
          //   children: [{ title: t('list'), path: paths.dashboard.job.list },
          //     // { title: t('create'), path: paths.dashboard.category.new }
          //   ],
          // },
          // {
          //   title: t('Blogs'),
          //   path: paths.dashboard.post.root,
          //   icon: ICONS.blog,
          //   children: [
          //     { title: t('list'), path: paths.dashboard.post.list },
          //     { title: t('create'), path: paths.dashboard.post.new },
          //   ],
          // },

          // {
          //   title: t('Wait List'),
          //   path: paths.dashboard.email.root,
          //   icon: ICONS.mail,
          //   children: [{ title: t('list'), path: paths.dashboard.email.list }],
          // },

        ],
      },
    ],
    [t]
  );

  return data;
}
